<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    <span v-if="!blockedUsers.length">
      {{ $t("users.noBlockedUsers") }}
    </span>

    <span v-else>
      {{ blockedUsers.length }}
      {{ $tc("users.users", blockedUsers.length) }}
      {{ $tc("users.blocked", blockedUsers.length) }}
    </span>

    <button class="button" @click="$emit('get-blocked-users')">
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <!-- &nbsp;
    <button
      class="button"
      @click="$emit('download-blocked-users-report')"
      :style="c1 ? 'margin-top: 1rem;' : ''"
    >
      <b-icon icon="save"></b-icon>
    </button> -->

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  mixins: [common],

  components: {
    goToDashboardButton
  },

  computed: {
    ...mapGetters(["blockedUsers"])
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
